import React from 'react';
import { FastField } from 'formik';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const WYSIWYG = props => (
  <FastField name={props.name}>
    {({ field, form }) => (
      <div className="form-group">
        <Editor
          onEditorStateChange={editorState => form.setFieldValue(field.name, editorState)}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          editorState={form.values[field.name] || EditorState.createEmpty()}
          toolbar={{
            options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'image', 'remove', 'history'],
            inline: {
              options: ['bold', 'italic', 'underline', 'strikethrough'],
            },
            blockType: {
              options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote'],
            },
          }}
        />
      </div>
    )}
  </FastField>
);

export default WYSIWYG;



// WEBPACK FOOTER //
// ./src/components/WYSIWYG/index.js